import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "tide-up-2.png",
    width: 64,
    height: 64
});